(() => {
  function initMasonry() {
    if (window.innerWidth > 749) return;

    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.grid__item'));
    if (!items.length) return;

    const gap = 8;
    const columns = 3;
    const gridWidth = grid.clientWidth;
    const itemWidth = (gridWidth - gap * (columns - 1)) / columns;

    const heights = new Array(columns).fill(0);

    items.forEach((item) => {
      item.style.width = `${itemWidth}px`;
      item.style.maxWidth = `${itemWidth}px`;

      const minHeight = Math.min(...heights);
      const columnIndex = heights.indexOf(minHeight);

      const x = columnIndex * (itemWidth + gap);
      const y = minHeight;

      item.style.transform = `translate(${x}px, ${y}px)`;

      heights[columnIndex] += item.offsetHeight + gap;
    });

    grid.style.height = `${Math.max(...heights)}px`;
  }

  function waitImagesThenRun() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const images = Array.from(grid.querySelectorAll('img'));

    let loaded = 0;

    if (!images.length) {
      initMasonry();
      return;
    }

    images.forEach((img) => {
      if (img.complete) {
        loaded++;
        if (loaded === images.length) initMasonry();
      } else {
        img.addEventListener('load', () => {
          loaded++;
          if (loaded === images.length) initMasonry();
        });
        img.addEventListener('error', () => {
          loaded++;
          if (loaded === images.length) initMasonry();
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', waitImagesThenRun);
  window.addEventListener('resize', () => {
    clearTimeout(window.__intoMasonryTimer);
    window.__intoMasonryTimer = setTimeout(waitImagesThenRun, 200);
  });
})();